<template>
  <div id="mainPage">
    <top-header />
    <left-menu />
    <div id="rightContent">
      <div id="content" class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from 'vue'
import LeftMenu from './leftMenu/index'
import TopHeader from './topHeader/index'
export default defineComponent({
  name: 'MainPage',
  components: {
    'top-header': TopHeader,
    'left-menu': LeftMenu
  },
  setup() {
    const state = reactive({
      clientWidth: 0
    })
    return {
      ...toRefs(state)
    }
  }
})
</script>
<style lang="less" scoped>
  #mainPage {
    display: flex;
    #rightContent {
      padding-top: 80px;
      width: 100%;
      background: #F8F9FB;
      height: 100vh;
      overflow-y: scroll;
      .content {
        padding: 0 20px;
        height: calc(100vh - 75px);
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }
</style>

